<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { shoppingCartPageUserDetail } from '@/api/biz/userDetail'

export default {
  name: 'ShoppingCartTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品名称'),
          dataIndex: 'productName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('图片'),
          dataIndex: 'productImage',
          scopedSlots: { customRender: 'productImage' },
          align: 'center'
        },
        {
          title: this.$t('规格'),
          dataIndex: 'skuName',
          align: 'center'
        },
        {
          title: this.$t('用户价格'),
          dataIndex: 'price',
          align: 'center'
        },
        {
          title: this.$t('加购数量'),
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      shoppingCartPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="changeType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.AccountChangeTypeEnum" :color="true" :color-array="['green', 'red']" :value="record.changeType" />
      </span>
      <span slot="payType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.PayTypeEnum" :color="true" :value="record.payType" />
      </span>
      <span slot="billType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.UserBalanceTypeEnum" :color="true" :value="record.billType" />
      </span>
      <template slot="productImage" slot-scope="text, record">
        <div style="width:40px;height:40px;margin: auto;">
          <img
            :src="record.productImage"
            style="width:40px;height:40px;"
            @click="handleRecordPreview(record.productImage)"
            alt="none"
          />
        </div>
      </template>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
